module.exports = __webpack_public_path__ + "static/media/kargah.6d92cf67.png";